import { useContext, useEffect } from "react";
import { CastContext } from "../../client/castContext.js";

export default function useAirPlayMedia(ref) {
  const { registerAirPlayMedia } = useContext(CastContext);
  useEffect(() => {
    if (!registerAirPlayMedia || !ref.current) return;
    return registerAirPlayMedia(ref.current);
  }, [ref, registerAirPlayMedia]);
}
